import get from "lodash/get";

export const getQuantityList = quantity =>
  Array.from(Array(quantity), (el, index) => index + 1);

export const determineIsSizeChart = sizeChart =>
  !!Object.keys(sizeChart).length &&
  typeof sizeChart[0] === "object" &&
  !!Object.keys(sizeChart[0]).length;
